import { useTranslation } from "react-i18next";
import { ContactDetailsSectionBreadcrumbs } from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";

export interface TicketsSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const TicketsSection = ({ enduser }: TicketsSectionProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs enduserId={enduser.id} breadcrumbs={[{ title: t("Tickets") }]} />
      <ContactDetailsSections.TicketsSection contact={enduser} />
    </div>
  );
};
